import axios from 'axios';
import endpoint from '@/api/endpoint';
axios.defaults.baseURL  = endpoint;

export default axios.create();
